import { useTranslation } from 'react-i18next';

const Policy = () => {
    const { t } = useTranslation();
    
    return (
        <div className='pb-[100px] max-w-5xl mx-auto px-4 sm:px-6 lg:px-8'>
            <div className='bg-white rounded-lg overflow-hidden'>
                <div className='py-16'>
                    <h1 className='text-3xl font-bold text-gray-900 mb-6'>{t('privacy.title')}</h1>
                    <p className='text-gray-600 mb-8'>{t('privacy.last_updated')}</p>
                    
                    <section className='mb-8'>
                        <p className='text-lg text-gray-700 mb-6'>
                            {t('privacy.intro')}
                        </p>
                        <p className='text-lg text-gray-700'>
                            {t('privacy.agreement')}
                        </p>
                    </section>

                    <div className='space-y-10'>
                        <section>
                            <h2 className='text-2xl font-semibold text-gray-800 mb-4'>{t('privacy.section1.title')}</h2>
                            <p className='text-gray-700 mb-4'>{t('privacy.section1.description')}</p>
                            
                            <div className='ml-4 space-y-4'>
                                <div>
                                    <h3 className='text-lg font-medium text-gray-800 mb-2'>{t('privacy.section1.personal.title')}</h3>
                                    <ul className='list-disc pl-5 text-gray-700 space-y-1'>
                                        {t('privacy.section1.personal.items', { returnObjects: true }).map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                                
                                <div>
                                    <h3 className='text-lg font-medium text-gray-800 mb-2'>{t('privacy.section1.non_personal.title')}</h3>
                                    <ul className='list-disc pl-5 text-gray-700 space-y-1'>
                                        {t('privacy.section1.non_personal.items', { returnObjects: true }).map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                                
                                <div>
                                    <h3 className='text-lg font-medium text-gray-800 mb-2'>{t('privacy.section1.cookies.title')}</h3>
                                    <p className='text-gray-700'>
                                        {t('privacy.section1.cookies.description')}
                                    </p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <h2 className='text-2xl font-semibold text-gray-800 mb-4'>{t('privacy.section2.title')}</h2>
                            <p className='text-gray-700'>
                                {t('privacy.section2.description')}
                            </p>
                            <ul className='list-disc pl-5 text-gray-700 mt-2 space-y-1'>
                                {t('privacy.section2.items', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </section>

                        <section>
                            <h2 className='text-2xl font-semibold text-gray-800 mb-4'>{t('privacy.section3.title')}</h2>
                            <p className='text-gray-700 mb-2'>
                                {t('privacy.section3.description')}
                            </p>
                            <ul className='list-disc pl-5 text-gray-700 space-y-1'>
                                {t('privacy.section3.items', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </section>

                        <section>
                            <h2 className='text-2xl font-semibold text-gray-800 mb-4'>{t('privacy.section4.title')}</h2>
                            <p className='text-gray-700'>
                                {t('privacy.section4.description')}
                            </p>
                        </section>

                        <section>
                            <h2 className='text-2xl font-semibold text-gray-800 mb-4'>{t('privacy.section5.title')}</h2>
                            <p className='text-gray-700 mb-2'>
                                {t('privacy.section5.description')}
                            </p>
                            <ul className='list-disc pl-5 text-gray-700 space-y-1 mb-4'>
                                {t('privacy.section5.items', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                            <p className='text-gray-700'>
                                {t('privacy.section5.contact')}
                            </p>
                        </section>

                        <section>
                            <h2 className='text-2xl font-semibold text-gray-800 mb-4'>{t('privacy.section6.title')}</h2>
                            <p className='text-gray-700'>
                                {t('privacy.section6.description')}
                            </p>
                        </section>

                        <section>
                            <h2 className='text-2xl font-semibold text-gray-800 mb-4'>{t('privacy.section7.title')}</h2>
                            <p className='text-gray-700'>
                                {t('privacy.section7.description')}
                            </p>
                        </section>

                        <section>
                            <h2 className='text-2xl font-semibold text-gray-800 mb-4'>{t('privacy.section8.title')}</h2>
                            <p className='text-gray-700'>
                                {t('privacy.section8.description')}
                            </p>
                        </section>

                        <section>
                            <h2 className='text-2xl font-semibold text-gray-800 mb-4'>{t('privacy.section9.title')}</h2>
                            <p className='text-gray-700 mb-2'>
                                {t('privacy.section9.description')}
                            </p>
                            <ul className='text-gray-700 space-y-1'>
                                <li>📧 {t('privacy.section9.email')}: <a href="mailto:info@oaacourses.com" className='text-blue-600 hover:underline'>info@oaacourses.com</a></li>
                                <li>🌐 {t('privacy.section9.website')}: <a href="https://oaacourses.com" className='text-blue-600 hover:underline'>https://oaacourses.com</a></li>
                            </ul>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Policy;